import React, { useState, useEffect, useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useStyles } from './styles';

const testimonials = [
  {
    name: 'Margarida Agrochão',
    info: 'PhD student at Caltech / USA',
    data: 'No other tool does what Mind the Graph does!',
    image: '/images/testimonials/picture_margarida.png',
    socialLink: 'https://www.linkedin.com/in/margarida-agrochao-phd-52176116/',
  },
  {
    name: 'Meredith Thompson',
    info: 'MIT Researcher / USA',
    data: 'Nice tools to conceptualize the graphical abstract for a journal article!',
    image: '/images/testimonials/picture_meredith.png',
    socialLink: 'https://www.linkedin.com/in/meredith-thompson-5abb9837',
  },
  {
    name: 'Susanne Fiedler',
    info: 'PhD Student at LMU / Germany',
    data: 'Very easy to use and graphs are designed quite quickly!',
    image: '/images/testimonials/picture_susanne.png',
    socialLink: 'https://www.facebook.com/zusanne.fiedler.7/',
  },
  {
    name: 'Shermel Sherman',
    info: 'Predoctoral Research Assistant at UT / USA',
    data: 'The nest building illustrations are perfect. Thank you!',
    image: '/images/testimonials/shermel.png',
    socialLink: 'https://www.researchgate.net/profile/Shermel_Sherman',
  },
  {
    name: 'Oscar García Miranda',
    info: 'Student at UDLAP  / Mexico',
    data: 'Thank you so much! They are awesome!',
    image: '/images/testimonials/oscar.png',
    socialLink: 'https://www.researchgate.net/profile/Oscar_Garcia-Miranda',
  },
  {
    name: 'Mahmoud Slim',
    info: 'Phd at Ave / Canada',
    data: 'Thank you so much for your assistance!',
    image: '/images/testimonials/mahmoud.png',
    socialLink: 'https://www.researchgate.net/profile/Mahmoud_Slim',
  },
  {
    name: 'Benjamin Zeitlin',
    info: 'Teacher at UOP / USA',
    data: 'Thank you, this was exactly what I needed!',
    image: '/images/testimonials/benjamin.png',
    socialLink: 'https://www.researchgate.net/profile/Benjamin_Zeitlin',
  },
  {
    name: 'Lara Moreno Zarate',
    info: 'PhD student at UCLM / Spain',
    data: 'Congrats for this platform and the work you are offering! it is great',
    image: '/images/testimonials/lara.png',
    socialLink: 'https://www.researchgate.net/profile/Lara_Moreno-Zarate',
  },
  {
    name: 'Selen Uman',
    info: 'PhD Student at UPENN / USA',
    data: 'The figures look great! thank you so much!',
    image: '/images/testimonials/selen.png',
    socialLink: 'https://www.gatescambridge.org/members-area/connect/directory/scholar/7252',
  },
  {
    name: 'Mohammed K Hankir',
    info: 'Basic Scientist at JMU / Germany',
    data: 'From day 1 the platform helped me to produce professional-looking slides for presentations and figures for publications.',
    image: '/images/testimonials/mohammed.png',
    socialLink: 'https://www.researchgate.net/profile/Mohammed_Hankir2',
  },
  {
    name: 'Emily Landon',
    info: 'Executive Medical Director at UC / USA',
    data: 'You guys are awesome!',
    image: '/images/testimonials/emily.png',
    socialLink: 'https://www.researchgate.net/profile/Emily_Landon2',
  },
  {
    name: 'Gabriela Torres Mattos',
    info: 'PhD student at UFRGS / Brazil',
    data: 'I bought the wrong plan and the support team was very attentive and solved my situation',
    image: '/images/testimonials/gabriela.png',
    socialLink: 'http://lattes.cnpq.br/6037855682278478',
  },
  {
    name: 'Benedikt Heuckmann',
    info: 'PostDoc at Leibniz Universität Hannover / Germany',
    data: 'Your support is very good and the illustrations are scientifically exact. Thank you so much for your help. This service is absolutely awesome',
    image: '/images/testimonials/benedikt.png',
    socialLink: 'https://www.researchgate.net/profile/Benedikt_Heuckmann',
  },
  {
    name: 'Sonali Raghunath',
    info: 'PhD Student at UMN / USA',
    data: 'It was easier to design exactly how I wanted to present the graphic in my scientific paper',
    image: '/images/testimonials/sonali.png',
    socialLink: 'https://www.researchgate.net/profile/Sonali_Raghunath2',
  },
  {
    name: 'Amro Hussien',
    info: 'PhD Student at ETH Zürich / Switzerland',
    data: 'Easy to use - Clean graphics - Big illustration library',
    image: '/images/testimonials/amro.png',
    socialLink: 'https://biomech.ethz.ch/the-institute/people/person-detail.html?persid=208489',
  },
  {
    name: 'Kaian Teles',
    info: 'PhD student at UnB / Brazil',
    data: 'I really like mind the graph because they have beautiful and useful templates',
    image: '/images/testimonials/kaian.png',
    socialLink: 'https://www.researchgate.net/profile/Kaian_Teles',
  },
];

const logoTestimonials = [
  {
    url: '/images/pricing/testimonials/logo/havard.svg',
    alt: 'Harvard',
    name: 'Harvard',
  },
  {
    url: '/images/pricing/testimonials/logo/mit.svg',
    alt: 'MIT',
    name: 'MIT',
  },
  {
    url: '/images/pricing/testimonials/logo/emrald.svg',
    alt: 'Emerald',
    name: 'Emerald',
  },
  {
    url: '/images/pricing/testimonials/logo/wolters.svg',
    alt: 'Wolters Kluwer',
    name: 'Wolters Kluwer',
  },
  {
    url: '/images/pricing/testimonials/logo/asco.svg',
    alt: 'ASCO',
    name: 'ASCO',
  },
  {
    url: '/images/pricing/testimonials/logo/cambridge.svg',
    alt: 'Cambridge',
    name: 'Cambridge',
  },
  {
    url: '/images/pricing/testimonials/logo/cornel.svg',
    alt: 'Cornell',
    name: 'Cornell',
  },
  {
    url: '/images/pricing/testimonials/logo/columbia.svg',
    alt: 'Columbia',
    name: 'Columbia',
  },
  {
    url: '/images/pricing/testimonials/logo/lse.svg',
    alt: 'LSE',
    name: 'LSE',
  },
  {
    url: '/images/pricing/testimonials/logo/havard.svg',
    alt: 'Harvard',
    name: 'Harvard',
  },
  {
    url: '/images/pricing/testimonials/logo/mit.svg',
    alt: 'MIT',
    name: 'MIT',
  },
  {
    url: '/images/pricing/testimonials/logo/emrald.svg',
    alt: 'Emerald',
    name: 'Emerald',
  },
  {
    url: '/images/pricing/testimonials/logo/wolters.svg',
    alt: 'Wolters Kluwer',
    name: 'Wolters Kluwer',
  },
  {
    url: '/images/pricing/testimonials/logo/asco.svg',
    alt: 'ASCO',
    name: 'ASCO',
  },
];

const TestimonialCarousel = () => {
  const classes = useStyles();
  const { t } = useTranslation('pricing');
  const [isMobile, setIsMobile] = useState(false);
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [carouselInterval, setCarouselInterval] = useState(null);

  const checkScreenSize = useCallback(() => {
    if (typeof window !== 'undefined') {
      setIsMobile(window.innerWidth < 768);
    }
  }, []);

  useEffect(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentTestimonialIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
      }, 4000);
      setCarouselInterval(interval);
    }

    return () => {
      if (carouselInterval) clearInterval(carouselInterval);
      window.removeEventListener('resize', checkScreenSize);
    };
  }, [isMobile]);

  const handleDotClick = (index) => {
    setCurrentTestimonialIndex(index);
  };

  return (
    // <Box className={classes.outerWrapper}>
    <Box className={classes.testimonialCarousel}>
      <Box className={classes.testimonialContainer}>
        <Box className={classes.titleSection}>
          <img src="/images/pricing/quotes.svg" alt="Quotes Icon" width={88} height={70} />
          <Box sx={{ flex: '1' }}>{t('loved_by_researchers')}</Box>
        </Box>

        {/* Carousel for Testimonials */}
        <Box
          className={classes.carouselContainer}
          style={{
            transform: false ? `translateX(-${currentTestimonialIndex * 100}%)` : 'none',
            // animation: false ? 'none' : `logoScroll 30s linear infinite`, // Dynamic animation speed
          }}
        >
          {testimonials.map((testimonial, index) => (
            <Box key={index} className={classes.testimonialCard}>
              {/* <Typography className={classes.testimonialData}>{testimonial.data}</Typography> */}
              <Typography
                dangerouslySetInnerHTML={{
                  __html: testimonial.data,
                }}
              ></Typography>
              <div className={classes.author}>
                <img
                  src={testimonial.image}
                  alt={`Avatar of ${testimonial.name}`}
                  className={classes.avatar}
                />
                <span
                  style={{
                    fontFamily: 'Lato',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontSize: '16px',
                    lineHeight: '26px',
                    letterSpacing: '0%',
                    // marginBottom: theme.spacing(2),
                  }}
                >
                  <a
                    href={testimonial.socialLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.socialLink}
                  >
                    {testimonial.name}
                  </a>
                </span>
              </div>
            </Box>
          ))}
        </Box>

        {/* Dots for Mobile */}
        {isMobile && (
          <Box className={classes.dots}>
            {testimonials.map((_, index) => (
              <Button
                key={index}
                className={currentTestimonialIndex === index ? classes.active : ''}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </Box>
        )}
      </Box>

      {/* Logo Carousel */}
      <Box className={classes.testimonialContainer}>
        <Box
          className={classes.logoCards}
          style={{
            animation: `$logoScroll ${logoTestimonials.length * 4}s linear infinite`, // Slower animation for logos
          }}
        >
          {logoTestimonials.map((logo, index) => (
            <Box key={index} className={classes.logo}>
              <img src={logo.url} alt={logo.name} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
    // </Box>
  );
};
export default TestimonialCarousel;
